module.exports = __webpack_public_path__ + "static/media/ios-cloudy-night.648e87f9.svg";